// tiny formatters used across cards/lists.

export const fmtInt = (n: number): string =>
  new Intl.NumberFormat('ru-RU').format(Math.round(n));

export const fmtPct = (n: number): string => `${Math.round(n * 100)}%`;

export const fmtRelative = (iso: string): string => {
  const ms = Date.now() - new Date(iso).getTime();
  const sec = Math.round(ms / 1000);
  if (sec < 60) return `${sec} с назад`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} мин назад`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} ч назад`;
  const d = Math.round(h / 24);
  return `${d} д назад`;
};

export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
